@use '@lib/assets/styles/main.scss' as *;

.chipColorClass {
  &.chip-disabled {
    color: $disable500;
  }

  &.chip-green {
    color: $success900;
  }

  &.chip-blue {
    color: $blue500;
  }

  &.chip-red {
    color: $error900;
  }

  &.chip-orange {
    color: $orange;
  }

  &.chip-white {
    color: $gray200;
  }

  &.chip-lime {
    color: $lime;
  }

  &.chip-gray {
    color: $gray400;
  }

  &.chip-black {
    color: $gray700;
  }

  &.chip-aquamarine {
    color: $aquamarine;
  }

  &.chip-violet {
    color: $violet;
  }

  &.chip-pink {
    color: $pink;
  }

  &.chip-corral {
    color: $corral;
  }

  &.chip-yellow {
    color: $yellow;
  }

  &.chip-brown {
    color: $brown;
  }

  &.chip-filter {
    color: $gray700;
  }
}

.root {
  border: none;
  font-weight: 600;
  box-sizing: border-box;
  z-index: 1;

  &:disabled {
    .loaderHolder {
      color: $gray900;
    }
  }

  /* Chip types */
  &.chip-disabled {
    background: $disable100;
    color: $disable500;

    .leftIcon {
      color: $disable500;
    }
  }

  &.chip-green {
    background: $greenLight;
    color: $gray900;

    .leftIcon {
      color: $success900;
    }
  }

  &.chip-blue {
    background: $blueLight;
    color: $gray900;

    .leftIcon {
      color: $blue500;
    }
  }

  &.chip-red {
    background: $error100;
    color: $gray900;

    .leftIcon {
      color: $error900;
    }
  }

  &.chip-orange {
    background: $orangeLight;
    color: $gray900;

    .leftIcon {
      color: $orange;
    }
  }

  &.chip-white {
    background: $gray0;
    color: $gray500;

    .leftIcon {
      color: $gray200;
    }
  }

  &.chip-lime {
    background: $limeLight;
    color: $gray900;

    .leftIcon {
      color: $lime;
    }
  }

  &.chip-gray {
    background: $gray50;
    color: $gray900;

    .leftIcon {
      color: $gray400;
    }
  }

  &.chip-black {
    background: $gray50;
    color: $gray700;

    .leftIcon {
      color: $gray700;
    }
  }

  &.chip-aquamarine {
    background: $aquamarineLight;
    color: $gray900;

    .leftIcon {
      color: $aquamarine;
    }
  }

  &.chip-violet {
    background: $violetLight;
    color: $gray900;

    .leftIcon {
      color: $violet;
    }
  }

  &.chip-pink {
    background: $pinkLight;
    color: $gray900;

    .leftIcon {
      color: $pink;
    }
  }

  &.chip-corral {
    background: $corralLight;
    color: $gray900;

    .leftIcon {
      color: $corral;
    }
  }

  &.chip-yellow {
    background: $yellowLight;
    color: $gray900;

    .leftIcon {
      color: $yellow;
    }
  }

  &.chip-brown {
    background: $brownLight;
    color: $gray900;

    .leftIcon {
      color: $brown;
    }
  }

  &.chip-filter {
    border-radius: 6px;
    border: 1px solid $gray200;
    background: $gray0;
    color: $gray700;

    &:hover {
      background: $gray10;
    }

    &.active,
    &[class*='active'],
    &:active {
      background: $gray50;
    }

    .leftIcon {
      color: $gray700;
    }
  }

  /* Button sizes */
  &.large {
    font-size: 14px;
    font-weight: 600;
    line-height: 140%;
    letter-spacing: 0.1px;
    height: 40px;
    min-height: 40px;
    padding: 0 16px;

    &.rounded {
      border-radius: 16px;
    }

    &.hasLabel {
      [class*='leftIcon'] {
        margin-left: -8px;
        margin-right: 8px;
      }

      [class*='rightIcon'] {
        margin-right: -8px;
      }
    }
  }

  &.medium {
    font-size: 15px;
    font-weight: 400;
    line-height: 140%;
    letter-spacing: 0.1px;
    height: 32px;
    min-height: 32px;
    padding: 0 12px;

    &.rounded {
      border-radius: 16px;
    }

    &.hasLabel {
      [class*='leftIcon'] {
        margin-left: -8px;
      }

      [class*='rightIcon'] {
        margin-right: -8px;
      }
    }
  }

  &.small {
    font-size: 13px;
    font-weight: 500;
    line-height: 20px;
    letter-spacing: -0.013px;
    height: 24px;
    min-height: 24px;

    &.rounded {
      border-radius: 12px;
    }

    &.hasLabel {
      [class*='leftIcon'] {
        margin-left: -2px;
      }

      [class*='rightIcon'] {
        margin-right: -2px;
      }

      .leftImage {
        margin-left: -4px;
      }

      .rightImage {
        margin-right: -4px;
      }
    }

    &:not(.withoutLabel) {
      padding: 0 6px;
    }

    &.withoutLabel {
      padding: 0 4px;
    }
  }

  &.extraSmall {
    font-size: 8px;
    font-weight: 500;
    line-height: 12px;
    letter-spacing: -0.013px;
    height: 12px;
    min-height: 12px;
    padding: 0 4px;
    border-radius: 4px;

    &.rounded {
      border-radius: 4px;
    }

    &.hasLabel {
      [class*='leftIcon'] {
        margin-left: 0;
      }

      [class*='rightIcon'] {
        margin-right: 0;
      }

      .leftImage {
        margin-left: 0;
      }

      .rightImage {
        margin-right: 0;
      }
    }
  }

  &.smallLeftIconOnly {
    height: 24px;
    background: transparent;
    border-color: transparent;
  }

  &.transparent {
    background: transparent;
  }
}

.rightIcon {
  color: $gray400;
  background: none;
  border: none;
  display: block;
  cursor: pointer;
  transition: color .3s ease;
  &:hover {
    color: $gray500;
  }
  i {
    display: block;
  }
}
